import React from 'react';

import Typography from '../../typography/typography';

import { useNavigateTo } from '../../../shared/hooks/hooks';

import './tab.scss';

export interface TabProps {
  className?: string;
  href?: string;
  isSelected?: boolean;
  onClick?: () => void;
}

function Tab(props: React.PropsWithChildren<TabProps>) {
  const { children, className = '', href, isSelected, onClick } = props;

  const navigateTo = useNavigateTo();

  function handleClick() {
    if (!isSelected) {
      if (href) {
        navigateTo(href);
      }
      typeof onClick === 'function' && onClick();
    }
  }

  return (
    <Typography
      aria-selected={isSelected}
      className={`tab ${className} ${isSelected ? 'tab--selected' : ''}`}
      onClick={handleClick}
      role="tab"
      styleName={isSelected ? 'selected' : 'default'}
      tag="button"
      weight="heavy"
    >
      {children}
    </Typography>
  );
}

export default Tab;
